import ContactUs from "../../Components/ContactUs/ContactUs";
import CustomSlider from "../../Components/CustomSlider/CustomSlider";
import {
  HomeTwoSection,
  LionSection,
  LatestProducts,
  VideoNewsSection
} from "../../Components/Section/Section";

const Home = () => {
  return (
    <div className="home-container">
      <CustomSlider />
      <HomeTwoSection />
      <LionSection />
      <LatestProducts />
      <VideoNewsSection />
      <section className="our-office-section-lusk">
        <div className="container" >
          <h2 className="font-48 cinzel capitalize " style={{ color: "white" }}>Global Offices</h2>
          <div className="flex">
            <p className="font-20 Optima mt-2">Lusk, WY</p>
            <p className="font-20 Optima mt-2">Boston MA</p>
            <p className="font-20 Optima mt-2">Montreal, QC</p>
          </div>
          <div className="flex" >
            <p className="font-20 Optima mt-2">Beiruit Lebanon</p>
            <p className="font-20 Optima mt-2">Jeddah, KSA
            </p>
            <p className="font-20 Optima mt-2">Dubai, UAE
            </p>
          </div>
        </div>
      </section>
      <ContactUs />
    </div>
  );
};

export default Home;
